import { render, staticRenderFns } from "./ServicosDisponiveis.vue?vue&type=template&id=b568bc44"
import script from "./ServicosDisponiveis.vue?vue&type=script&lang=js"
export * from "./ServicosDisponiveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports